<template>
  <div id="app">
    <navbar />

    <router-view name="dialog"></router-view>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
export default {
  components: { Navbar },
  metaInfo: {
    title: 'Mustard School',
    titleTemplate: '%s | Mustard School',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Empowering young people to be fully alive, forever.'
      }
    ]
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/index.scss';
</style>
